export default __webpack_public_path__ + "/assets/map-pin-blue.24dfaf4a4bf18af47ee9bba1695a464d.png";